// extracted by mini-css-extract-plugin
module.exports = {"container":"VehicleBrandsTab_container__1KkwH"};